export const BRANCH_STATUS_TYPE = strings => {
  return {
    active: strings.active,
    inactive: strings.inactive,
    closed: strings.closed,
    banned: strings.banned
  }
}
